<template>
  <div class="metrics-card">
    <div class="metrics-card-title">
      {{ title }}
    </div>
    <div class="metrics-card-value">
      {{ formatNumberCompact(value, calculateAffix(type).prefix, calculateAffix(type).suffix) }}
      <span v-if="trend" :class="clsx('metrics-card-trend', { 'metrics-card-trend--up': trend > 0, 'metrics-card-trend--down': trend < 0 })">{{ formatNumberWithSign(trend) }}%</span>
    </div>
  </div>
</template>

<script>
import clsx from 'clsx';
import { compactNumberFormatter, numberFormatter } from '@/shared/lib/number';

export default {
  props: {
    title: {
      type: String,
      default: '',
      required: false,
    },
    value: {
      type: Number,
      default: 0,
      required: false,
    },
    type: {
      type: String,
      default: 'currency',
      required: false,
    },
    trend: {
      type: Number,
      default: 0,
      required: false,
    }
  },
  mixins: [ numberFormatter, compactNumberFormatter ],
  methods: {
    clsx,
    calculateAffix(type) {
      const affixes = {
        amount: { prefix: '₴', suffix: '' },
        earnings: { prefix: '₴', suffix: '' },
        count: { prefix: '', suffix: ' ШТ' },
      };

      return affixes[type] || { prefix: '', suffix: '' };
    },
  },
};
</script>

<style lang="scss" scoped>
.metrics-card {
  background-color: #fff;
  border: 1px solid #E2E8F0;
  border-radius: 7px;
  padding: 20px 24px;
  height: 100%;

  &-title {
    font-size: 16px;
    font-weight: 500;
    color: #6B7280;
  }

  &-value {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 20px;
    font-weight: 500;
    color: #020617;

    @media (max-width: 550px) {
      flex-direction: column;
      align-items: flex-start;
    }
  }

  &-trend {
    font-size: 12px;
    font-weight: 600;
    border-radius: 12px;
    margin: 3px;
    padding: 4px 10px;

    &--up {
      background-color: #E3F4E3;
      color: #65C565;
    }

    &--down {
      background-color: #FF3B30;
      color: #FFF6F4;
    }
  }
}
</style>
